package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class PatientData(
    val address: String? = null,
    val anamnesis_vitae: String? = null,
    val birth_date: String? = null,
    val city: String? = null,
    val created_at: String? = null,
    val deleted_at: String? = null,
    val discount: Int? = null,
    val gender: String? = null,
    val id: Int,
    val id_card: String? = null,
    val id_number: String? = null,
    val mime: String? = null,
    val name: String = "",
    val original_photoname: String? = null,
    val patronymic: String? = null,
    val phone: String? = null,
    val photoname: String? = null,
    val pivot: PatientPivot? = null,
    val position: String? = null,
    val special_conditions: String? = null,
    val surname: String? = null,
    val updated_at: String? = null,
    val workplace: String? = null,
)